import * as React from 'react';
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Checkbox } from '@material-ui/core';
import { StyledComponentProps } from '@material-ui/core/styles';

import { IMediaQueryProps } from '../../../layout/withMediaQuery';
import { IState as IReminderState } from '../../../common/store/reminders/state';
import { IActions as IReminderActions } from '../../../common/store/reminders/actions/creators';
import CancelButton from '../../../ui-components/Button/CancelButton';
import { reminder } from '../../../model/reminder';
import SaveButton from '../../../ui-components/Button/SaveButton';
import TextField from '../../../ui-components/TextField/TextField';
import { SearchBoxApi } from '../../../ui-components/SearchBoxApi/SearchBoxApi';
import { contact, emptyContact } from '../../../model/contact';
import { invokeApi } from '../../../common/networking/invoker';
import DatePicker from '../../../ui-components/DatePicker/DatePicker';

interface IProps extends IMediaQueryProps, IReminderActions, IReminderState, IIProps {
}

interface IIProps extends StyledComponentProps {
    // IContactActions,
    onCancel: () => any;
    onSave: (reminder: reminder) => any;
    open: boolean;
    reminder: reminder;
    canChangeContact?: boolean;
}
interface IState {
    reminder: reminder;
    contact: contact;
}

const templateSearchBoxContact = (contact?: contact) => {
    return contact ? {
        label: (contact.surname ? contact.surname + " " + contact.name + " - " : "") + contact.email,
        value: contact
    } : undefined;
}
const searchContactsSearchBox = (search: string, take?: number): Promise<Array<contact>> => {
    return new Promise((resolve, reject) => {
        invokeApi({
            path: take ? `/api/Contacts?fullnameOrEmail=${search}&take=${take}`
                : `api/Contacts?fullnameOrEmail=${search}`,
            method: 'GET',
            responseType: "json",
        }).then(val => {
            resolve(val);
        }).catch(val => {
            reject(val)
        })
    })
}

export default class ReminderDialog extends React.Component<IIProps, IState> {

    // state = { trainer: this.props.reminder }

    /**
     *
     */
    constructor(p, c) {
        super(p, c);
        this.state = {
            reminder: this.props.reminder,
            contact: emptyContact(),
            // reservationList: NormalizedObjectsFactory()
        }
    }

    // getContactDescription = (contact: contact) => {
    //     return contact.surname ? (contact.surname + " " + contact.name) : contact.email;
    // }

    componentDidMount() {
    }
    componentDidUpdate(prevProps: IProps) {
        // if (this.props.reminder !== undefined && prevProps.reminder !== undefined ) {
        if (this.props.reminder._id !== prevProps.reminder._id) {
            this.setState({ reminder: this.props.reminder });
        }
    }
    setContact = (c: contact) => {
        if (c !== undefined) {
            this.setState({ reminder: { ...this.state.reminder, userId: c.sub, email: c.email }, contact: c });
        }
        else {
            this.setState({ reminder: { ...this.state.reminder, userId: '', email: '' }, contact: c });
        }
    }
    setNotes = (text: any) => {
        this.setState({ reminder: { ...this.state.reminder, notes: text } });
    }
    setAppNotes = (text: any) => {
        this.setState({ reminder: { ...this.state.reminder, appNotes: text } });
    }
    setExpireDate = (d: Date) => {
        this.setState({ reminder: { ...this.state.reminder, expiresOn: d } });
    }
    setBlockAccess = (val: boolean) => {
        this.setState({ reminder: { ...this.state.reminder, blockAccess: val } });
        // this.props.setBlockDate(this.state.reminder.expiresOn);
    }

    render() {
        // const { classes } = this.props;
        var title = "Aggiungi un promemoria";
        //Prenotazioni di {this.getContactDescription(this.props.contact)}
        return (
            <Dialog
                open={this.props.open}
                onClose={(e) => this.props.onCancel()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {<DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
                <DialogContent>
                    <Grid container>
                        <Grid item sm={12}>
                            <TextField
                                label='Memo:'
                                multiline={true}
                                rows={10}
                                value={this.state.reminder?.notes}
                                onChange={(val) => { this.setNotes(val) }}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <TextField
                                label='Memo app utente:'
                                multiline={true}
                                rows={2}
                                value={this.state.reminder?.appNotes}
                                onChange={(val) => { this.setAppNotes(val) }}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <DatePicker
                                key={`reminder-expireon-from-date-picker`}
                                label="Data Scdenza Promemoria"
                                fullWidth
                                clearable={true}
                                value={this.state.reminder?.expiresOn === undefined ? null : this.state.reminder.expiresOn}
                                onChange={(d) => this.setExpireDate(d)}
                            />
                        </Grid>
                        <Grid item sm={12} style={{ padding: 5 }}>
                            <FormControlLabel
                                control={<Checkbox
                                    checked={this.state.reminder?.blockAccess}
                                    onChange={(e, val) => this.setBlockAccess(val)}
                                />}
                                label={'Blocca accesso alla scadenza'}
                            />
                        </Grid>
                        {this.props.canChangeContact ?
                            <>
                                {/* Visualizzo la sezione solo se devo scegliere l'utente in fase di creazione nuovo REMINDER
                            quindi non dalla pagina del contatto */}
                                <Grid item xs={12} style={{ margin: "5px" }}>
                                    <SearchBoxApi<contact>
                                        selectedItem={this.state.contact} // props.selectedUser
                                        openOnFocus
                                        doFilter
                                        disabled={false} // props.addInProgress
                                        listSize={10}
                                        getItems={searchContactsSearchBox}
                                        label={"Utente"}
                                        placeholder={"Digitare cognome o nome"}
                                        templateItem={templateSearchBoxContact}
                                        onSelectedChange={(item) => { this.setContact(item) }} />
                                </Grid>
                                <Grid item sm={12}>
                                    <TextField
                                        label="Email"
                                        value={this.state.reminder?.email}
                                        disabled
                                    />
                                </Grid>
                                <Grid item sm={12}>
                                    <TextField
                                        label="UserId"
                                        value={this.state.reminder?.userId}
                                        disabled
                                    />
                                </Grid>
                            </>
                            : <></>}
                    </Grid>
                </DialogContent >
                <DialogActions>
                    <SaveButton onClick={() => this.props.onSave(this.state.reminder)} />
                    <CancelButton onClick={this.props.onCancel} />
                </DialogActions>
            </Dialog >
        );
    }
}

// const mapStateToProps = (state: IApplicationState, ownProps: any): any => {
//     return {
//         ...ownProps,
//         // ...state.reservations
//     }
// }

// const mapDispatchToProps = (dispatch: any) => ({
//     ...remindersActions(dispatch)
// })

// export default connect(mapStateToProps, mapDispatchToProps)((WithMediaQuery(ReminderDialog))) as React.ComponentType<IIProps>;